import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicsReportsUploadModalListItem = _resolveComponent("ClinicsReportsUploadModalListItem")!
  const _component_BaseTableBodyWrapper = _resolveComponent("BaseTableBodyWrapper")!

  return (_openBlock(), _createBlock(_component_BaseTableBodyWrapper, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
        return (_openBlock(), _createBlock(_component_ClinicsReportsUploadModalListItem, {
          key: `${index}_upload_item`,
          item: row,
          onOnChecked: checked => _ctx.onChecked({checked, index})
        }, null, 8, ["item", "onOnChecked"]))
      }), 128))
    ]),
    _: 1
  }))
}